import { useTranslation } from "react-i18next";
import flagBR from "@/assets/flags/brasil.png";
import flagUS from "@/assets/flags/estados-unidos.png";
import flagES from "@/assets/flags/espanha.png";
import flagFR from "@/assets/flags/franca.png";
import flagDE from "@/assets/flags/alemanha.png";
import flagIT from "@/assets/flags/italia.png";

const flags: Record<string, { label: string; icon: string }> = {
  pt: { label: "Português", icon: flagBR },
  en: { label: "English", icon: flagUS },
  es: { label: "Español", icon: flagES },
  fr: { label: "Français", icon: flagFR },
  de: { label: "Deutsch", icon: flagDE },
  it: { label: "Italiano", icon: flagIT },
};

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split("-")[0] || "pt";
  const normalizedLang = Object.keys(flags).includes(currentLang) ? currentLang : "pt";
  const availableLanguages = Object.keys(flags).filter((lang) => lang !== normalizedLang);

  return (
    <div className="flex items-center gap-1.5">
      {availableLanguages.map((lang) => (
        <button
          key={lang}
          onClick={() => i18n.changeLanguage(lang)}
          title={flags[lang].label}
          className="w-7 h-7 rounded-full overflow-hidden flex items-center justify-center hover:scale-125 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-1 focus:ring-offset-background"
        >
          <img src={flags[lang].icon} alt={flags[lang].label} className="w-full h-full object-cover" />
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
